import { useFormik } from "formik"
import { useEffect, useState } from "react"
import { Modal } from "react-bootstrap"
import { layThongTinCauHinhNgayLamViec, luuCauHinhNgayLamViec } from "../../services/setting"
import { toast } from "react-toastify";
import { Tabs, Button, Switch, Table } from "antd";
import { SaveOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';
import Column from "antd/es/table/Column"


const NgayLamViec = () => {
    const [openModalLuu, setOpenModalLuu] = useState<boolean>(false);
    const [stateThuHai, setStateThuHai] = useState<boolean>(false);
    const [stateThuBa, setStateThuBa] = useState<boolean>(false);
    const [stateThuTu, setStateThuTu] = useState<boolean>(false);
    const [stateThuNam, setStateThuNam] = useState<boolean>(false);
    const [stateThuSau, setStateThuSau] = useState<boolean>(false);
    const [stateThuBay, setStateThuBay] = useState<boolean>(false);
    const [stateChuNhat, setStateChuNhat] = useState<boolean>(false);
    const {values, setFieldValue, setErrors, setTouched } = useFormik({
        initialValues: {
            "thuHai": 0,
            "thuBa": 0,
            "thuTu": 0,
            "thuNam": 0,
            "thuSau": 0,
            "thuBay": 0,
            "chuNhat": 0,
        },
        onSubmit: (values) => {
            setOpenModalLuu(true)
        }
    });

    const layThongTin = async () => {
        var data = await layThongTinCauHinhNgayLamViec();
        setFieldValue("thuHai", data.thuHai || 0);
        setStateThuHai(data.thuHai == 0 ? true : false);
        setFieldValue("thuBa", data.thuBa || 0);
        setStateThuBa(data.thuBa == 0 ? true : false);
        setFieldValue("thuTu", data.thuTu || 0);
        setStateThuTu(data.thuTu == 0 ? true : false);
        setFieldValue("thuNam", data.thuNam || 0);
        setStateThuNam(data.thuNam == 0 ? true : false);
        setFieldValue("thuSau", data.thuSau || 0);
        setStateThuSau(data.thuSau == 0 ? true : false);
        setFieldValue("thuBay", data.thuBay || 0);
        setStateThuBay(data.thuBay == 0 ? true : false);
        setFieldValue("chuNhat", data.chuNhat || 0);
        setStateChuNhat(data.chuNhat == 0 ? true : false);
    }

    const onSave = async (request: any) => {
        let rs = await luuCauHinhNgayLamViec(request);
        if (rs === true) {
            setErrors({});
            setTouched({});
            toast.success('Lưu thông tin thành công');
            setOpenModalLuu(false);
        }
        else {
            toast.success('Lưu thông tin không thành công')
            setOpenModalLuu(false)
        }
    };
    useEffect(() => {
        layThongTin();
    }, []);
    return <section>
        <Modal show={openModalLuu} onHide={() => setOpenModalLuu(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Lưu ngày làm việc</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Bạn có muốn lưu ngày làm việc không?
            </Modal.Body>
            <Modal.Footer style={{
                "display": "flex",
                "justifyContent": "space-between"
            }}>
                <Button type="primary" danger className="btn-sm" onClick={() => setOpenModalLuu(false)}>
                    Đóng
                </Button>
                <Button type="primary" className="btn-sm" onClick={() => onSave(values)}>
                    Đồng ý
                </Button>
            </Modal.Footer>
        </Modal>
        <Tabs
            defaultActiveKey="1"
            tabBarExtraContent={
                <Button
                    onClick={() => {
                        setOpenModalLuu(true)
                    }}
                    icon={<SaveOutlined rev="" />}
                    type="primary"
                >
                    Lưu
                </Button>
            }
            items={[
                {
                    key: '1',
                    label: 'Ngày làm việc',
                    children:
                        <div className="card">
                            <Table
                                locale={{ emptyText: "Không có dữ liệu" }}
                                dataSource={[
                                    { ngayTrongTuan: 'Thứ Hai', lamViec: stateThuHai },
                                    { ngayTrongTuan: 'Thứ Ba', lamViec: stateThuBa },
                                    { ngayTrongTuan: 'Thứ Tư', lamViec: stateThuTu },
                                    { ngayTrongTuan: 'Thứ Năm', lamViec: stateThuNam },
                                    { ngayTrongTuan: 'Thứ Sáu', lamViec: stateThuSau },
                                    { ngayTrongTuan: 'Thứ Bảy', lamViec: stateThuBay },
                                    { ngayTrongTuan: 'Chủ Nhật', lamViec: stateChuNhat }
                                ]}
                                pagination={false}
                            >
                                <Column
                                    width="7%"
                                    title="STT"
                                    key="STT"
                                    align="center"
                                    render={(value, record, index) =>
                                    (
                                        <>
                                            {index + 1}
                                        </>
                                    )
                                    }
                                />
                                <Column title="Ngày trong tuần" dataIndex="ngayTrongTuan" key="ngayTrongTuan" align="center" />
                                <Column
                                    title="Làm việc"
                                    key="lamViec"
                                    align="center"
                                    render={(record: any) => (
                                        <Switch
                                            checked={record.lamViec}
                                            checkedChildren={<CheckOutlined rev="" />}
                                            unCheckedChildren={<CloseOutlined rev="" />}
                                            onChange={(checked) => {
                                                switch (record.ngayTrongTuan) {
                                                    case 'Thứ Hai':
                                                        setStateThuHai(checked);
                                                        setFieldValue("thuHai", checked ? 0 : 1);
                                                        break;
                                                    case 'Thứ Ba':
                                                        setStateThuBa(checked);
                                                        setFieldValue("thuBa", checked ? 0 : 1);
                                                        break;
                                                    case 'Thứ Tư':
                                                        setStateThuTu(checked);
                                                        setFieldValue("thuTu", checked ? 0 : 1);
                                                        break;
                                                    case 'Thứ Năm':
                                                        setStateThuNam(checked);
                                                        setFieldValue("thuNam", checked ? 0 : 1);
                                                        break;
                                                    case 'Thứ Sáu':
                                                        setStateThuSau(checked);
                                                        setFieldValue("thuSau", checked ? 0 : 1);
                                                        break;
                                                    case 'Thứ Bảy':
                                                        setStateThuBay(checked);
                                                        setFieldValue("thuBay", checked ? 0 : 1);
                                                        break;
                                                    case 'Chủ Nhật':
                                                        setStateChuNhat(checked);
                                                        setFieldValue("chuNhat", checked ? 0 : 1);
                                                        break;
                                                    default:
                                                        break;
                                                }
                                            }}
                                        />
                                    )}
                                />

                            </Table>
                        </div>
                },
            ]}>
        </Tabs>
    </section>
}

export default NgayLamViec